import API from "../../api/api";
import Auth from "../../auth.js";
import { Link } from "react-router-dom";
import "../../styles/css/users/sign.css";
import React, { Component } from "react";
import { Header, Footer } from "../../components";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import ErrorOutileIcon from "@material-ui/icons/ErrorOutline";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import CircularProgress from "@material-ui/core/CircularProgress";

class Signin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      rememberMe: false,

      usernameEmpty: false,
      passwordEmpty: false,

      isSubmitted: false,
      userLoginSuccess: true,
      isLoginLoading: false,
      errorMsg: "",

      isPageLoading: true,
    };
    this._isMounted = false;
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    localStorage.removeItem("token");
    this._isMounted = true;
    this.setState({ isPageLoading: false });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleSubmit(event) {
    event.preventDefault();

    if (this.state.username === "") {
      this.setState({ usernameEmpty: true });
    } else {
      this.setState({ usernameEmpty: false });
    }
    if (this.state.password === "") {
      this.setState({ passwordEmpty: true });
    } else {
      this.setState({ passwordEmpty: false });
    }

    const user = {
      email: this.state.username,
      password: this.state.password,
    };

    if (this.state.username !== "" && this.state.password !== "") {
      this.setState({
        isLoginLoading: true,
        isSubmitted: false,
        userLoginSuccess: true,
        errorMsg: "",
      });

      API.post("login", user)
        .then((res) => {
          console.log("res", res);
          const token = res.data.response.token;
          const userRole = res.data.user[0].user_roles[0].name;
          const userRoleID = res.data.user[0].user_roles[0].id;
          const userId = res.data.user[0].id;
          const userName = res.data.user[0].name;

          localStorage.setItem("token", token);
          localStorage.setItem("userRole", userRole);
          localStorage.setItem("userRoleId", userRoleID);
          localStorage.setItem("userId", userId);
          localStorage.setItem("userName", userName);

          API.defaults.headers["Authorization"] = "Bearer " + token;

          this.setState({ isLoginLoading: false });

          Auth.login(() => {
            this.props.history.push("/");
          });
        })
        .catch((error) => {
          if (error.response !== undefined) {
            this.setState({
              isLoginLoading: false,
              isSubmitted: true,
              userLoginSuccess: false,
              errorMsg: error.response.data.error,
            });
          } else {
            this.setState({
              isLoginLoading: false,
              isSubmitted: true,
              userLoginSuccess: false,
              errorMsg: "Network Error",
            });
          }

          // console.log("AXIOS ERROR: ", error.response.data.error);
        });
    }
  }

  render() {
    const {
      isSubmitted,
      userLoginSuccess,
      isLoginLoading,
      isPageLoading,
    } = this.state;

    return (
      <div className={`mainDiv`}>
        <Header />
        {isPageLoading ? (
          <div className="preloader">
            <CircularProgress className="preloaderCircle" />
          </div>
        ) : (
          <div className="signInMain">
            <div className="landingMainHead landingMainHeadSign">
              <div className="landingMain">
                <div className="breadCrubmContainer removePaddingLogin breadCrubmContainerSign">
                  <div className="breadCrumb">
                    <a href="https://surveysource.com/" className="prevLinks">
                      Home
                    </a>
                    <span>&nbsp;&gt;&nbsp;</span>
                    <span className="currLink">Login</span>
                  </div>
                </div>
                <div className="landingMainLeft landingMainLeftSign">
                  <div className="landingMainActives">
                    <p className="loginMainActivesTitle landingMainActivesTitleMobile">
                      Login to get started
                    </p>
                  </div>
                  <div className="logingFormMain">
                    <form onSubmit={this.handleSubmit}>
                      <TextField
                        id="username"
                        label="Email"
                        className=""
                        fullWidth
                        margin="normal"
                        name="username"
                        value={this.state.username}
                        onChange={this.handleInputChange}
                      />
                      <div
                        className="ErrorLog ErrorLogReg"
                        style={{
                          display: this.state.usernameEmpty ? "block" : "none",
                        }}
                      >
                        <span>Email is required</span>
                      </div>
                      <TextField
                        id="password"
                        label="Password"
                        className=""
                        type="password"
                        fullWidth
                        margin="normal"
                        name="password"
                        value={this.state.password}
                        onChange={this.handleInputChange}
                      />
                      <div
                        className="ErrorLog ErrorLogReg"
                        style={{
                          display: this.state.passwordEmpty ? "block" : "none",
                        }}
                      >
                        <span>Password is required</span>
                      </div>
                      <div className="inlineFields">
                        <FormControlLabel
                          className="inputRemember"
                          control={
                            <Checkbox value="rememberMe" color="primary" />
                          }
                          label="Remember me"
                          name="stayLogin"
                        />
                        {/* <Link to="#" className="forgetPw">
                          Forgot password?
                        </Link> */}
                      </div>
                      <button type="submit" className="loginBtn">
                        {isLoginLoading ? (
                          <CircularProgress className="circularColor1" />
                        ) : (
                          <div>
                            <span>Login</span>
                          </div>
                        )}
                      </button>
                      <div
                        className="userCreationMessage messageDiv"
                        id="userCreationMessage"
                      >
                        {isSubmitted ? (
                          userLoginSuccess ? (
                            <div className="messageBody messageDivSub messageLogin userCreationSuccessColor">
                              <div className="messageAction">
                                <ErrorOutileIcon />
                              </div>
                              <div className="userCreationSuccess">
                                User logged successfully
                              </div>
                            </div>
                          ) : (
                            <div className="messageBody messageDivSub messageLogin userCreationFailColor">
                              <div className="messageAction">
                                <ErrorOutileIcon />
                              </div>
                              <div className="userCreationFail">
                                {this.state.errorMsg}
                              </div>
                            </div>
                          )
                        ) : null}
                      </div>
                      {/* <div className="registrationLinks">
                        <span>Don't have an account ? Signup as </span>
                        <Link to="/signupsurveyor" className="registerLink">
                          Surveyor
                        </Link>
                        <span>&nbsp;or&nbsp;</span>
                        <Link to="/signup" className="registerLink">
                          Title company
                        </Link>
                      </div> */}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <Footer />
      </div>
    );
  }
}

export default Signin;



// WEBPACK FOOTER //
// ./src/pages/Users/Signin.js